module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    staticClass: "app-layout",
    attrs: {
      "id": "app"
    }
  }, [_c('header-component'), _vm._v(" "), (_vm.Helpers.isTouch()) ? _c('div', {
    staticClass: "mobileWrapper"
  }, [(_vm.isLandingPage) ? _c('landing') : _c('router-view')], 1) : _c('div', {
    staticClass: "deskWrapper"
  }, [(_vm.isLandingPage) ? _c('landing') : _c('div', {
    staticClass: "pages-wrapper",
    on: {
      "DOMMouseScroll": _vm.onMouseWheel,
      "mousewheel": _vm.onMouseWheel
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('footer-component'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "show-popup",
      "appear": ""
    }
  }, [(_vm.popup) ? _c('base-popup') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dced5584","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 515
// module chunks = 1